/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import CustomAlert from "components/CustomAlert";

// Data
import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useMaterialUIController, setLoading } from "context";
import ConfirmDialog from "components/ConfirmDialog";
import TableSkeleton from "components/TableSkeleton";
import { ProductLineAPI } from "api/ProductLineAPI";
import permissions from "permissions";


export default function ListProductLine() {
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [controller, dispatch] = useMaterialUIController();
  const [id, setId] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [productLines, setProductLines] = useState([]);
  const { user, loading, admin } = controller;
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state;

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => setAlert(false);

  const handleClick = () => {
    navigate('create');
  }

  const handleDelete = (id) => {
    setId(id)
    setIsDeleting(true);
  }

  const handleCancelDelete = () => {
    setIsDeleting(false);
  };

  const handleConfirmDelete = () => {
    return deleteProductLine(id)
  };

  const renderTable = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Linea", accessor: "linea", align: "left" },
      { Header: "Nombre Linea", accessor: "nombre_linea", align: "left" },
      { Header: "acción", accessor: "action", align: "center" },
    ];

    productLines.map((element) => {
      rows = [...rows,
      {
        linea: element.linea,
        nombre_linea: element.nombre_linea,
        action: (
          <MDBox>
            {(user?.permissions?.includes(permissions.product_lines[2]) || user?.role === admin) && (
              <IconButton component={Link} aria-label="edit" value={element.id} to={element.id + '/edit'}>
                <EditIcon />
              </IconButton>
            )}
            {(user?.permissions?.includes(permissions.product_lines[3]) || user?.role === admin) && (
              <IconButton aria-label="delete" value={element.id} onClick={() => handleDelete(element.id)}>
                <DeleteIcon />
              </IconButton>
            )}
          </MDBox>
        ),
      }
      ]
    });

    return <DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
  }, [productLines])

  const getProductLines = (signal) => {
    return ProductLineAPI.index(signal)
      .then(response => {
        setProductLines(response.productLines)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  const deleteProductLine = (id) => {
    return ProductLineAPI.delete(id)
      .then(response => {
        const updatedProductLines = productLines.filter((productLine) => productLine.id !== response.productLine);
        setProductLines(updatedProductLines);
        handleAlert(response.message, 'success');
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        handleCancelDelete();
      });

  }

  useEffect(() => {
    if (message) {
      handleAlert(message, 'success');
    }
  }, [message]);


  useEffect(() => {
    window.history.replaceState({}, document.title)
    const abortController = new AbortController();
    const signal = abortController.signal

    setLoading(dispatch, true)
    getProductLines(signal);

    return () => {
      abortController.abort();
    };
  }, []);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
            <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', pb: 3 }}>
              {(user?.permissions?.includes(permissions.product_lines[1]) || user?.role === admin) && (
                <MDButton variant="gradient" color="info" onClick={handleClick}>Crear</MDButton>
              )}
            </MDBox>
            <Card>
              <MDBox>
                {loading ? <TableSkeleton></TableSkeleton> :
                  <MDBox pt={3}>
                    {renderTable}
                  </MDBox>}
                {isDeleting && (<ConfirmDialog onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} ></ConfirmDialog>)}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}











